import {
    Button,
    DateRangeField,
    Form,
    FormFooter,
    FormSection,
    MultiSelectField,
    Page,
    SelectOption,
    toast
} from '@7shifts/sous-chef';
import { handleError } from 'api/apiUtils';
import { getQueues } from 'api/queuesApi';
import { getLeadsPerDayReport } from 'api/reportsApi';
import { useFormik } from 'formik';
import { __ } from 'i18n/translate';
import { useEffect, useState } from 'react';
import UserSelectField from 'sharedComponents/UserSelectField';
import { Queue } from 'types';
import { downloadCSV } from 'utils/csv';
import { dateYearMonthDay } from 'utils/date';

type FormData = {
    date: { start: Date; end: Date };
    user: SelectOption<number> | null;
    queues: { id: string; value: string }[];
};

const LeadsPerDayPage = () => {
    const [queues, setQueues] = useState<Queue[]>([]);

    useEffect(() => {
        getQueues()
            .then((data) => setQueues(data))
            .catch(handleError);
    }, []);

    const formik = useFormik<FormData>({
        initialValues: {
            date: {
                start: new Date(),
                end: new Date()
            },
            queues: [],
            user: null
        },
        onSubmit: (values, { setSubmitting }) => {
            setSubmitting(true);
            getLeadsPerDayReport(
                dateYearMonthDay(values.date.start),
                dateYearMonthDay(values.date.end),
                values.queues.map((a) => a.value),
                values.user?.value || null
            )
                .then((data) => {
                    downloadCSV(data, 'leads-per-day.csv');
                })
                .catch(() => {
                    toast('Something went wrong', 'danger');
                })
                .finally(() => formik.setSubmitting(false));
        }
    });

    return (
        <Page
            breadcrumbs={__('main.reports')}
            title={__('reportsPage.reportLeadsUserPerDay')}
            subtitle={__('reportsPage.reportLeadsUserPerDayDescription')}
        >
            <Form formik={formik}>
                <FormSection as="card">
                    <DateRangeField
                        name="date"
                        label="Período"
                        format="dd/MM/yyyy"
                    />
                    <MultiSelectField
                        name="queues"
                        placeholder={__('component.select.placeholder')}
                        label={__('main.queues')}
                        options={queues.map((queue) => ({
                            label: queue.name,
                            value: queue.id
                        }))}
                    />
                    <UserSelectField
                        name="user"
                        placeholder={__('dashboardPage.allUsers')}
                        label="Usuário"
                        onChange={(userOption) =>
                            formik.setFieldValue('user', userOption)
                        }
                    />
                </FormSection>
                <FormFooter
                    actions={{
                        primary: (
                            <Button type="submit" loading={formik.isSubmitting}>
                                {__('main.downloadCSV')}
                            </Button>
                        )
                    }}
                />
            </Form>
        </Page>
    );
};

export default LeadsPerDayPage;
